<template>
  <div>
    <Report :componentId="studentId" :componentName="componentName"></Report>
  </div>
</template>

<script>
import Report from '@/views/consultant/student/new/main/evaluationReport'
export default {
  name: "report",
  data(){
    let names=JSON.parse(sessionStorage.getItem('mineStudentData'))
    return{
      studentId:sessionStorage.getItem('myStudentStudentId'),
      componentName:names&&names.name||''
    }
  },
  components:{Report}
}
</script>

<style scoped>

</style>